import { Pipe, PipeTransform } from '@angular/core';
import { ProductConfigService } from '@shared/core';
import { EServiceTypeKey } from '@skyeng/libs/shared/stk';

export type StkViewType = 'title' | 'shortTitle';

@Pipe({
  name: 'stk',
})
export class StkTitlePipe implements PipeTransform {
  constructor(private productConfigService: ProductConfigService) {}

  transform(stk: EServiceTypeKey, type: StkViewType = 'shortTitle'): string {
    return this.productConfigService.getByStk(stk as EServiceTypeKey)?.[type] || stk;
  }
}
